import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAddDetails } from '../../actions/steward_action';
import Water from './Water/Water';
import Waste from './Waste/Waste';
import Sourcing from './Sourcing/Sourcing';
import PeopleCommunity from './PeopleCommunity/PeopleCommunity';
import CommunityInvestment from './CommunityInvestment/CommunityInvestment';
import { MESSAGE_TYPE_ERROR } from '../../reducer/General/constants';

const StewardShip = () => {
    const dispatch = useDispatch()
    const buttonList = useSelector((state) => state.emissions.formList)
    const formsLoading = useSelector((state) => state.emissions.formsLoading)
    //const buttonList = ['Water', 'Waste', 'Sourcing', 'People and Community', 'Community Investment']
    const [selectedValue, setSelectedValue] = useState('l');

    const tabList = {
        water_stewardship: 'Water Stewardship',
        waste: 'Packaging Waste', sourcing: 'Sourcing',
        people_and_community: 'People and Communities', community_investments: 'Community Investment'
    }

    const handleClick = (e) => {
        if (e.target.value !== selectedValue) {
            dispatch({
                type: 'SET_INITIAL_STATUS',
            })
            setSelectedValue(e.target.value)
        }
    }

    useEffect(() => {
        if (!formsLoading) {
            if (buttonList.length === 0) {
                const event = new CustomEvent('globalMessageEvent', { detail: {
                    text: "You don't have permission to access country, try to contact Admin",
                    type: MESSAGE_TYPE_ERROR,
                    canDismiss: false
                }});
                document.dispatchEvent(event);
            } else {
                dispatch({
                    type: 'SET_INITIAL_STATUS',
                });

                for (let i = 0; i < buttonList.length; i++) {
                    if (buttonList[i]) {
                        setSelectedValue(buttonList[i]);
                        break;
                    }
                }
            }
        }
        
    }, [buttonList, formsLoading]);

    useEffect(() => {
        dispatch(getAddDetails())
    }, [])

    return (
        <div >
            {buttonList.map((btn) => {
                return (
                    <span style={{ marginLeft: "1rem" }}
                        key={btn}>
                        <button style={{
                            margin: "1rem",
                            backgroundColor: selectedValue === btn ? "#FBC02D" : "white",
                            border: selectedValue === btn ? "1px solid #FBC02D" : "1px solid #E0E0E0",
                            color: "black",
                            borderRadius: "5px",
                            fontSize: ".85rem",
                            width: "12rem",
                            height: "2rem"
                        }}
                            onClick={handleClick}
                            value={btn} >
                            {tabList[btn]}
                        </button >
                    </span>
                )
            }
            )}
            <div>
                {selectedValue === 'water_stewardship' && <Water />}
                {selectedValue === 'waste' && <Waste />}
                {selectedValue === 'sourcing' && <Sourcing />}
                {selectedValue === 'people_and_community' && <PeopleCommunity />}
                {selectedValue === 'community_investments' && <CommunityInvestment />}
            </div>
        </div>
    )
}

export default StewardShip